// Generated by scripts/write-oblivion-mine-replay-fixtures.ts.
// Do not edit manually.

import type { OblivionMineReplayEventType } from "./event-adapter";

export interface OblivionMineReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface OblivionMineReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: OblivionMineReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface OblivionMineReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "oblivion-mine";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly OblivionMineReplayFixturePlayer[];
  readonly events: readonly OblivionMineReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const OBLIVION_MINE_REPLAY_FIXTURES: Record<
  string,
  OblivionMineReplayFixture
> = {
  "heuristic-2p": {
    schemaVersion: 1,
    gameType: "oblivion-mine",
    scenario: "heuristic-2p",
    source: "generated",
    capturedAt: "2026-06-23T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "흑 (휴리스틱)",
        role: "host",
      },
      {
        id: "p2",
        name: "백 (휴리스틱)",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "heuristic-2p",
            players: [
              {
                playerId: "p1",
                label: "흑 탐험가",
              },
              {
                playerId: "p2",
                label: "백 탐험가",
              },
            ],
            phase: "lay-mines",
            mines: [],
            positions: {
              p1: {
                row: 0,
                col: 0,
              },
              p2: {
                row: 10,
                col: 10,
              },
            },
            treasures: [
              {
                row: 5,
                col: 5,
                collectedBy: null,
              },
              {
                row: 0,
                col: 10,
                collectedBy: null,
              },
              {
                row: 10,
                col: 0,
                collectedBy: null,
              },
            ],
            minesLaid: {
              p1: false,
              p2: false,
            },
            scores: {
              p1: 0,
              p2: 0,
            },
            firstPlayerId: "p1",
            currentPlayerId: "p1",
            moveNumber: 0,
            lastHit: null,
            winnerId: null,
            lastAction: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "LayMines",
        userId: "p1",
        payload: {
          playerId: "p1",
          cells: [
            {
              row: 4,
              col: 5,
            },
            {
              row: 5,
              col: 4,
            },
            {
              row: 5,
              col: 6,
            },
            {
              row: 6,
              col: 5,
            },
            {
              row: 3,
              col: 5,
            },
            {
              row: 4,
              col: 4,
            },
            {
              row: 4,
              col: 6,
            },
            {
              row: 5,
              col: 3,
            },
            {
              row: 5,
              col: 7,
            },
            {
              row: 6,
              col: 4,
            },
            {
              row: 6,
              col: 6,
            },
            {
              row: 7,
              col: 5,
            },
            {
              row: 2,
              col: 5,
            },
            {
              row: 3,
              col: 4,
            },
            {
              row: 3,
              col: 6,
            },
          ],
          moveNumber: 0,
        },
      },
      {
        sequenceNumber: 3,
        eventType: "LayMines",
        userId: "p2",
        payload: {
          playerId: "p2",
          cells: [
            {
              row: 4,
              col: 5,
            },
            {
              row: 5,
              col: 4,
            },
            {
              row: 5,
              col: 6,
            },
            {
              row: 6,
              col: 5,
            },
            {
              row: 3,
              col: 5,
            },
            {
              row: 4,
              col: 4,
            },
            {
              row: 4,
              col: 6,
            },
            {
              row: 5,
              col: 3,
            },
            {
              row: 5,
              col: 7,
            },
            {
              row: 6,
              col: 4,
            },
            {
              row: 6,
              col: 6,
            },
            {
              row: 7,
              col: 5,
            },
            {
              row: 2,
              col: 5,
            },
            {
              row: 3,
              col: 4,
            },
            {
              row: 3,
              col: 6,
            },
          ],
          moveNumber: 1,
        },
      },
      {
        sequenceNumber: 4,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 1,
          },
          moveNumber: 2,
        },
      },
      {
        sequenceNumber: 5,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 9,
            col: 10,
          },
          moveNumber: 3,
        },
      },
      {
        sequenceNumber: 6,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 2,
          },
          moveNumber: 4,
        },
      },
      {
        sequenceNumber: 7,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 8,
            col: 10,
          },
          moveNumber: 5,
        },
      },
      {
        sequenceNumber: 8,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 3,
          },
          moveNumber: 6,
        },
      },
      {
        sequenceNumber: 9,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 7,
            col: 10,
          },
          moveNumber: 7,
        },
      },
      {
        sequenceNumber: 10,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 4,
          },
          moveNumber: 8,
        },
      },
      {
        sequenceNumber: 11,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 6,
            col: 10,
          },
          moveNumber: 9,
        },
      },
      {
        sequenceNumber: 12,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 5,
          },
          moveNumber: 10,
        },
      },
      {
        sequenceNumber: 13,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 10,
          },
          moveNumber: 11,
        },
      },
      {
        sequenceNumber: 14,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 1,
            col: 5,
          },
          moveNumber: 12,
        },
      },
      {
        sequenceNumber: 15,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 9,
          },
          moveNumber: 13,
        },
      },
      {
        sequenceNumber: 16,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 2,
            col: 5,
          },
          moveNumber: 14,
        },
      },
      {
        sequenceNumber: 17,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 8,
          },
          moveNumber: 15,
        },
      },
      {
        sequenceNumber: 18,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 1,
          },
          moveNumber: 16,
        },
      },
      {
        sequenceNumber: 19,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 7,
          },
          moveNumber: 17,
        },
      },
      {
        sequenceNumber: 20,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 2,
          },
          moveNumber: 18,
        },
      },
      {
        sequenceNumber: 21,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 9,
            col: 10,
          },
          moveNumber: 19,
        },
      },
      {
        sequenceNumber: 22,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 3,
          },
          moveNumber: 20,
        },
      },
      {
        sequenceNumber: 23,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 8,
            col: 10,
          },
          moveNumber: 21,
        },
      },
      {
        sequenceNumber: 24,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 4,
          },
          moveNumber: 22,
        },
      },
      {
        sequenceNumber: 25,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 7,
            col: 10,
          },
          moveNumber: 23,
        },
      },
      {
        sequenceNumber: 26,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 5,
          },
          moveNumber: 24,
        },
      },
      {
        sequenceNumber: 27,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 6,
            col: 10,
          },
          moveNumber: 25,
        },
      },
      {
        sequenceNumber: 28,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 1,
            col: 5,
          },
          moveNumber: 26,
        },
      },
      {
        sequenceNumber: 29,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 10,
          },
          moveNumber: 27,
        },
      },
      {
        sequenceNumber: 30,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 2,
            col: 5,
          },
          moveNumber: 28,
        },
      },
      {
        sequenceNumber: 31,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 9,
          },
          moveNumber: 29,
        },
      },
      {
        sequenceNumber: 32,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 3,
            col: 5,
          },
          moveNumber: 30,
        },
      },
      {
        sequenceNumber: 33,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 8,
          },
          moveNumber: 31,
        },
      },
      {
        sequenceNumber: 34,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 1,
          },
          moveNumber: 32,
        },
      },
      {
        sequenceNumber: 35,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 7,
          },
          moveNumber: 33,
        },
      },
      {
        sequenceNumber: 36,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 2,
          },
          moveNumber: 34,
        },
      },
      {
        sequenceNumber: 37,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 6,
          },
          moveNumber: 35,
        },
      },
      {
        sequenceNumber: 38,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 3,
          },
          moveNumber: 36,
        },
      },
      {
        sequenceNumber: 39,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 9,
            col: 10,
          },
          moveNumber: 37,
        },
      },
      {
        sequenceNumber: 40,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 4,
          },
          moveNumber: 38,
        },
      },
      {
        sequenceNumber: 41,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 8,
            col: 10,
          },
          moveNumber: 39,
        },
      },
      {
        sequenceNumber: 42,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 5,
          },
          moveNumber: 40,
        },
      },
      {
        sequenceNumber: 43,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 7,
            col: 10,
          },
          moveNumber: 41,
        },
      },
      {
        sequenceNumber: 44,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 1,
            col: 5,
          },
          moveNumber: 42,
        },
      },
      {
        sequenceNumber: 45,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 6,
            col: 10,
          },
          moveNumber: 43,
        },
      },
      {
        sequenceNumber: 46,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 2,
            col: 5,
          },
          moveNumber: 44,
        },
      },
      {
        sequenceNumber: 47,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 10,
          },
          moveNumber: 45,
        },
      },
      {
        sequenceNumber: 48,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 3,
            col: 5,
          },
          moveNumber: 46,
        },
      },
      {
        sequenceNumber: 49,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 9,
          },
          moveNumber: 47,
        },
      },
      {
        sequenceNumber: 50,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 4,
            col: 5,
          },
          moveNumber: 48,
        },
      },
      {
        sequenceNumber: 51,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 8,
          },
          moveNumber: 49,
        },
      },
      {
        sequenceNumber: 52,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 1,
          },
          moveNumber: 50,
        },
      },
      {
        sequenceNumber: 53,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 7,
          },
          moveNumber: 51,
        },
      },
      {
        sequenceNumber: 54,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 2,
          },
          moveNumber: 52,
        },
      },
      {
        sequenceNumber: 55,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 6,
          },
          moveNumber: 53,
        },
      },
      {
        sequenceNumber: 56,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 3,
          },
          moveNumber: 54,
        },
      },
      {
        sequenceNumber: 57,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 5,
          },
          moveNumber: 55,
        },
      },
      {
        sequenceNumber: 58,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 4,
          },
          moveNumber: 56,
        },
      },
      {
        sequenceNumber: 59,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 4,
            col: 5,
          },
          moveNumber: 57,
        },
      },
      {
        sequenceNumber: 60,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 5,
          },
          moveNumber: 58,
        },
      },
      {
        sequenceNumber: 61,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 9,
            col: 10,
          },
          moveNumber: 59,
        },
      },
      {
        sequenceNumber: 62,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 6,
          },
          moveNumber: 60,
        },
      },
      {
        sequenceNumber: 63,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 8,
            col: 10,
          },
          moveNumber: 61,
        },
      },
      {
        sequenceNumber: 64,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 7,
          },
          moveNumber: 62,
        },
      },
      {
        sequenceNumber: 65,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 7,
            col: 10,
          },
          moveNumber: 63,
        },
      },
      {
        sequenceNumber: 66,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 8,
          },
          moveNumber: 64,
        },
      },
      {
        sequenceNumber: 67,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 6,
            col: 10,
          },
          moveNumber: 65,
        },
      },
      {
        sequenceNumber: 68,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 9,
          },
          moveNumber: 66,
        },
      },
      {
        sequenceNumber: 69,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 10,
          },
          moveNumber: 67,
        },
      },
      {
        sequenceNumber: 70,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 10,
          },
          moveNumber: 68,
        },
      },
      {
        sequenceNumber: 71,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 9,
          },
          moveNumber: 69,
        },
      },
      {
        sequenceNumber: 72,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 9,
          },
          moveNumber: 70,
        },
      },
      {
        sequenceNumber: 73,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 8,
          },
          moveNumber: 71,
        },
      },
      {
        sequenceNumber: 74,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 8,
          },
          moveNumber: 72,
        },
      },
      {
        sequenceNumber: 75,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 7,
          },
          moveNumber: 73,
        },
      },
      {
        sequenceNumber: 76,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 7,
          },
          moveNumber: 74,
        },
      },
      {
        sequenceNumber: 77,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 6,
          },
          moveNumber: 75,
        },
      },
      {
        sequenceNumber: 78,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 6,
          },
          moveNumber: 76,
        },
      },
      {
        sequenceNumber: 79,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 5,
          },
          moveNumber: 77,
        },
      },
      {
        sequenceNumber: 80,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 5,
          },
          moveNumber: 78,
        },
      },
      {
        sequenceNumber: 81,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 5,
            col: 4,
          },
          moveNumber: 79,
        },
      },
      {
        sequenceNumber: 82,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 4,
          },
          moveNumber: 80,
        },
      },
      {
        sequenceNumber: 83,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 9,
          },
          moveNumber: 81,
        },
      },
      {
        sequenceNumber: 84,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 3,
          },
          moveNumber: 82,
        },
      },
      {
        sequenceNumber: 85,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 8,
          },
          moveNumber: 83,
        },
      },
      {
        sequenceNumber: 86,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 2,
          },
          moveNumber: 84,
        },
      },
      {
        sequenceNumber: 87,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 7,
          },
          moveNumber: 85,
        },
      },
      {
        sequenceNumber: 88,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 1,
          },
          moveNumber: 86,
        },
      },
      {
        sequenceNumber: 89,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 6,
          },
          moveNumber: 87,
        },
      },
      {
        sequenceNumber: 90,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 0,
            col: 0,
          },
          moveNumber: 88,
        },
      },
      {
        sequenceNumber: 91,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 5,
          },
          moveNumber: 89,
        },
      },
      {
        sequenceNumber: 92,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 1,
            col: 0,
          },
          moveNumber: 90,
        },
      },
      {
        sequenceNumber: 93,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 4,
          },
          moveNumber: 91,
        },
      },
      {
        sequenceNumber: 94,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 2,
            col: 0,
          },
          moveNumber: 92,
        },
      },
      {
        sequenceNumber: 95,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 3,
          },
          moveNumber: 93,
        },
      },
      {
        sequenceNumber: 96,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 3,
            col: 0,
          },
          moveNumber: 94,
        },
      },
      {
        sequenceNumber: 97,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 2,
          },
          moveNumber: 95,
        },
      },
      {
        sequenceNumber: 98,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 4,
            col: 0,
          },
          moveNumber: 96,
        },
      },
      {
        sequenceNumber: 99,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 1,
          },
          moveNumber: 97,
        },
      },
      {
        sequenceNumber: 100,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          to: {
            row: 5,
            col: 0,
          },
          moveNumber: 98,
        },
      },
      {
        sequenceNumber: 101,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          to: {
            row: 10,
            col: 0,
          },
          moveNumber: 99,
        },
      },
    ],
    notes: [
      "망각의 지뢰는 비대칭 숨김정보 게임 — 지뢰 위치는 서버 권위. 픽스처 init은 양측 지뢰 전체(복기용)를 담고, 화면은 미발동 지뢰를 마스킹(관전 뷰)한다.",
      "공정 휴리스틱(no-oracle): 봇은 마스킹된 뷰만 사용(상대 미발동 지뢰 안 보임). 매설=중앙 인접 15칸(양측 동일·겹침), 이동=최근접 보물 그리디. 상대 지뢰를 못 봐서 밟고 knockback → 발동 후 소모 → 종결.",
      "결과: 매설 2수 + 이동 98수(피격 7회) → 백(p2) 승리 (보물 2/3).",
    ],
  },
};
